import React from 'react';

const SkibusIcon = ({
  fillColorCircle = '#FFDC0D',
  fillColorArrow = '#ffffff',
  size = '65',
}) => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 45.437 45.437">
      <path d="M41.403 11.11c-.37-3.627-.962-6.45-1.897-7.56-3.855-4.565-30.86-4.9-33.925 0-.75 1.2-1.275 4.013-1.628 7.566-1.14.134-2.026 1.093-2.026 2.267v4.443c0 .988.626 1.82 1.5 2.146-.207 6.998-.04 14.3.27 17.93 0 2.803 1.884 2.338 1.884 2.338h1.765v3.026c0 1.2 1.237 2.17 2.76 2.17 1.527 0 2.764-.97 2.764-2.17V40.24h20.533v3.026c0 1.2 1.236 2.17 2.762 2.17 1.524 0 2.76-.97 2.76-2.17V40.24h.58s2.217.304 2.36-1.016c0-3.62.227-11.646.04-19.22.928-.292 1.606-1.148 1.606-2.178v-4.443c.002-1.202-.928-2.177-2.107-2.273zM12.176 4.2H32.91v3.137H12.177V4.2zm.296 32.467c-1.628 0-2.947-1.32-2.947-2.948s1.32-2.947 2.947-2.947 2.948 1.32 2.948 2.946c0 1.627-1.32 2.947-2.948 2.947zm20.328 0c-1.627 0-2.95-1.32-2.95-2.948s1.322-2.947 2.95-2.947 2.947 1.32 2.947 2.946c0 1.627-1.32 2.947-2.947 2.947zm3.747-12.9H8.54V9.077h28.007v14.69z" />
    </svg>
  );
};

export default SkibusIcon;
